// Code generated by Slice Machine. DO NOT EDIT.

import dynamic from 'next/dynamic';

export const components = {
  rogs_slice: dynamic(() => import('./RogsSlice')),
  terms_of_service_slice: dynamic(() => import('./TermsOfServiceSlice')),
};
